export const ApiCallStatusStates = {
    ERROR: "error",
    IDLE: "idle",
    LOADING: "loading",
    SUCCESS: "success",
} as const;

export type ApiCallStatus = typeof ApiCallStatusStates[keyof typeof ApiCallStatusStates];